'use client'
import React, {useEffect} from "react";

interface Props {
    className?: string
    children: React.ReactNode
}

export default function DialogToggle({className, children}: Props) {
    const toggleDialog = () => {
        const dialog = (document.getElementById('announcement') as HTMLDialogElement)
        if(!dialog.open) {
            dialog.showModal()
        } else {
            dialog.close()
        }
    }

    useEffect(() => {
        if(sessionStorage.getItem('DialogSession') !== 'true') {
            toggleDialog()
            sessionStorage.setItem('DialogSession', 'true');
        }
    }, []);

    return (
        <div className={className} onClick={toggleDialog}>
            {children}
        </div>
    )
}